import React from "react";
import SavingsCard from "./Components/SavingCard";
import { list1, list2, list3, list4 } from "./Data/Saving";
import { Currency } from "./../../Public/assets/index";
import Lottie from "react-lottie";
import { lottieOptions } from "./../../Utils/helperFunction";

function SecondSection() {
  const cards = [list1, list2, list3, list4];
  return (
    // <div className="md:pb-0 md:pt-0 md:px-18 lg:pr-8   ">
    <div className=" py-10 lg:flex justify-center items-center lg:my-[100px] xl:px-[134px] ">
      <div className="lg:w-[55%] 2lg:w-[60%] xl:w-1/2">
        <h1 className="font-IvyJournal font-semibold text-[32px] leading-[40.51px] md:text-[42px] md:leading-[65.2px] text-ivygray px-6 xl:px-0">
          Get{" "}
          <span className=" font-IvyJournal text-blueish font-[600]">
            more{" "}
          </span>{" "}
          from one
        </h1>
        <h2 className="mt-2.5 text-geomanistgray font-AktivGrotesk font-normal text-base leading-[19px] px-6 xl:px-0 md:max-w-[80%] ">
          With just a single account, you gain access to multiple benefits
          designed to simplify and enhance your experience. Dive into a world of
          endless financial possibilities.
        </h2>
        <div className="hidden px-6 xl:px-0 mt-20 md:grid grid-cols-2 gap-y-[30px] max-w-[85%] lg:max-w-full xl:max-w-[85%]">
          {cards.map((item, index) => (
            <SavingsCard key={index} list={item} />
          ))}
        </div>

        <div className="md:hidden flex gap-x-[26px] justify-between overflow-x-scroll py-6 scrollbar-hide px-6">
          {cards.map((item, index) => (
            <SavingsCard key={index} list={item} />
          ))}
        </div>
      </div>
      <div className="md:mt-0  !md:px-18 !lg:px-0 !md:py-9 !xxl:px-14 md:flex justify-center mx-auto sm:max-w-[582px] lg:w-[40%] xxl:w-1/2">
        <Lottie options={lottieOptions(Currency)} />
      </div>
    </div>
  );
}

export default SecondSection;
